// Which prose summary, if any, fills the slot at the top of a candidate's CV
// tab. Shared by the agency candidate page and the triage detail panel so both
// surfaces agree on the rule.

// Bullhorn's `description` is whatever went into that field upstream — often a
// CV, pasted or parsed into the record, which is why the median run is ~4k
// characters. Its short tail is the exception and it is noise: production has
// rows reading just "Resume", "Privacy" or "Avacado". Below this many
// characters it isn't a summary worth titling as one. Set where the junk stops
// and terse-but-real notes begin — 27 of ~97k rows fall under it, vs 1,172
// under 100 chars.
export const MIN_BULLHORN_SUMMARY_LENGTH = 50;

// bullhornSummaryFor returns the Bullhorn description to render as the
// "Bullhorn Summary", or null when the slot should not show one. A parsed CV
// always wins: when there's an AI summary the Bullhorn blurb is not shown.
export function bullhornSummaryFor(candidateProfile) {
  if (candidateProfile?.resumeSummary) {
    return null;
  }

  const description = candidateProfile?.externalDescription?.trim();
  if (!description || description.length < MIN_BULLHORN_SUMMARY_LENGTH) {
    return null;
  }

  return description;
}
